module.exports = __webpack_public_path__ + "static/img/company_3.7c04c1f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/company_3.webp
// module id = rtuo
// module chunks = 1